import { OrganizationDashboardIcon } from '@moovly/ui';
import { CurrentUserInfo } from '../../hooks/useCurrentUser';
import { BackofficeRoute } from '../../types/route.interfaces';

import GroupsList from './pages/GroupsPage';

const organizationRoutes: (currentUser: CurrentUserInfo) => BackofficeRoute[] = ({ isOrganizationAdmin }) => {
  const routes = [];
  if (isOrganizationAdmin) {
    routes.push({
      sidebar: {
        icon: OrganizationDashboardIcon,
        translationKey: 'menu.organization.groups',
      },

      path: '/organization/groups',
      element: <GroupsList />,
    });
  }

  return routes;
};

export default organizationRoutes;
